<template>
    <v-app>
        <v-main>
            <div class="wrapper">
                <v-container fluid class="fill-height">
                    <v-row align="center">
                        <v-col cols="6">
                            <img src="@/assets/login_welcome.svg" alt="Image" style="padding-left: 100px; width: 85%" />
                        </v-col>
                        <v-col cols="6">
                            <div class="login-wrapper">
                                <img alt="Logo" width="200" src="@/assets/app_logo.svg" style="margin-bottom: 50px" />
                                <img alt="login" style="cursor: pointer" width="100" src="@/assets/ms-signin.svg" @click.stop="signIn" />
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </v-main>
    </v-app>
</template>

<script>
import MSALInstance from '@/auth/auth';

export default {
    name: 'LoginPage',
    methods: {
        async signIn() {
            return MSALInstance.login();
        },
    },
};
</script>

<style scoped>
.wrapper {
    background: url('@/assets/background.svg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: 100vh;
}
.login-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
